import { render, staticRenderFns } from "./SuspiciousActivityReviews.vue?vue&type=template&id=57d17d30&scoped=true&"
import script from "./SuspiciousActivityReviews.vue?vue&type=script&lang=js&"
export * from "./SuspiciousActivityReviews.vue?vue&type=script&lang=js&"
import style0 from "./SuspiciousActivityReviews.vue?vue&type=style&index=0&id=57d17d30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d17d30",
  null
  
)

export default component.exports